
import { ActionIcon, Box, Button, Modal, Stack, Text } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconEye } from "@tabler/icons-react";
import { useState } from "react";

interface DetailPopupProps {
  attribute86?: string;
}

const DetailPopup: React.FC<DetailPopupProps> = ({ attribute86 }) => {
    const [opened, { open, close }] = useDisclosure(false);
  
  // Parse dữ liệu từ attribute86
  let marketingData: any = null;
  try {
    if (attribute86) {
      marketingData = JSON.parse(attribute86);
    }
  } catch (error) {
    console.error("Error parsing attribute86:", error);
  }

  // Mapping các giá trị hiển thị
  const getSourceName = (source: string) => {
    const sourceMap: any = {
      'facebook': 'Facebook',
      'google': 'Google',
      'zalo': 'Zalo',
      'tiktok': 'TikTok',
      'instagram': 'Instagram',
    };
    return sourceMap[source?.toLowerCase()] || source || "Không xác định";
  };

  const getMediumName = (medium: string) => {
    const mediumMap: any = {
      'cpc': 'Quảng cáo trả phí (CPC)',
      'organic': 'Tự nhiên',
      'referral': 'Giới thiệu',
      'social': 'Mạng xã hội',
      'email': 'Email Marketing',
    };
    return mediumMap[medium?.toLowerCase()] || medium || "Không xác định";
  };

  return (
    <>
      <ActionIcon
        variant="light"
        aria-label="Xem thông tin nguồn & chiến dịch"
        color="cyan"
        onClick={open}
        style={{ pointerEvents: "auto" }}
      >
        <IconEye size={20} />
      </ActionIcon>

      <Modal
        opened={opened}
        onClose={close}
        title={<h2>Thông tin nguồn & chiến dịch marketing</h2>}
        centered
        size="lg"
      >
        <Stack gap="md" mt="md">
          {marketingData ? (
            <Box>
              <Text size="md" mb="xs">
                <b>Nguồn truy cập:</b> {getSourceName(marketingData.utm_source)}
              </Text>
              <Text size="md" mb="xs">
                <b>Hình thức tiếp cận:</b> {getMediumName(marketingData.utm_medium)}
              </Text>
              {marketingData.utm_campaign && marketingData.utm_campaign !== "none" && (
                <Text size="md" mb="xs">
                  <b>Chương trình marketing:</b> {marketingData.utm_campaign}
                </Text>
              )}
              {marketingData.utm_term && marketingData.utm_term !== "none" && (
                <Text size="md" mb="xs">
                  <b>Nhóm khách hàng:</b> {marketingData.utm_term}
                </Text>
              )}
              {marketingData.utm_content && marketingData.utm_content !== "none" && (
                <Text size="md" mb="xs">
                  <b>Nội dung quảng cáo:</b> {marketingData.utm_content}
                </Text>
              )}
              {marketingData.fbclid && (
                <Text size="xs" c="dimmed" mt="lg" style={{ wordBreak: "break-all" }}>
                  <b>Facebook Click ID:</b> {marketingData.fbclid}
                </Text>
              )}
            </Box>
          ) : (
            <Text c="dimmed">Chưa có thông tin marketing</Text>
          )}
        </Stack>
      </Modal>
    </>
  );
};

export default DetailPopup;
